export default {
  sharedPageInfo: {},
  sharedPage: {},
  sharedPageResults: {},
  selectedOptions: {},
};
